import * as React from 'react'
import { StyleguideExample, StyleguidePart } from '../../../../../Shared/Hoppinger.Styleguide/Frontend'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ObjectsLists = () => (
  <>
    <StyleguidePart title="Ordered list (WYSIWYG)" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <WYSIWYGList kind="ol" />
      </StyleguideExample>
    </StyleguidePart>

    <StyleguidePart title="Unordered list (WYSIWYG)" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <WYSIWYGList kind="ul" />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

const WYSIWYGList = (props: { kind: 'ol' | 'ul' }) => {
  const Tag = props.kind
  return (
    <div className="text--styled">
      <Tag>
        <li>
          Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Lorem ipsum dolor, sit amet consectetur
          adipisicing elit. Voluptates, sint.
        </li>
        <li>
          Aenean lacinia bibendum nulla sed consectetur. Lorem ipsum, dolor sit amet consectetur adipisicing elit.
          Laboriosam ipsum deserunt ducimus quibusdam, magnam sunt.
        </li>
        <li>
          Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Morbi leo risus, porta
          ac consectetur ac, vestibulum at eros.
          <Tag>
            <li>
              Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Lorem ipsum dolor sit amet consectetur.
              <Tag>
                <li>
                  Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Lorem ipsum dolor sit amet consectetur.
                </li>
                <li>
                  Aenean lacinia bibendum nulla sed consectetur. Lorem ipsum dolor, sit amet consectetur adipisicing
                  elit. Dolores temporibus similique amet a neque, tempore esse voluptate! Eos, officiis veniam.
                </li>
              </Tag>
            </li>
            <li>
              Aenean lacinia bibendum nulla sed consectetur. Lorem ipsum dolor, sit amet consectetur adipisicing elit.
              Dolores temporibus similique amet a neque, tempore esse voluptate! Eos, officiis veniam.
            </li>
          </Tag>
        </li>
        <li>
          Nullam quis risus eget urna mollis ornare vel eu leo. Morbi leo risus, porta ac consectetur ac, vestibulum at
          eros.
        </li>
      </Tag>
    </div>
  )
}
